/**
 * The Hazcheck Campaigns mark.
 *
 * ── WHY THIS IS THE SUPPLIED ARTWORK, NOT A TRACE ─────────────────────────────────
 *
 * Earlier revisions hand-drew the mark as SVG. It took two rounds of geometry corrections and was
 * still a reconstruction, so it is now `public/brand/campaigns-mark.png` — the artwork itself,
 * downscaled from the 1254px original. A logo is the one asset where "close enough" is not a
 * standard: it appears beside the same mark on three other products, and a redraw that is 3% off is
 * visibly off when they sit side by side.
 *
 * Transparent PNG rather than SVG because that is the format the artwork exists in. If a vector ever
 * lands, swap the `<img>` for the inline SVG here and nothing else in the app changes.
 *
 * ── SIZES ─────────────────────────────────────────────────────────────────────────
 *
 * The asset is 256px square and renders at 24–32px, so it has 8× of headroom for any display
 * density. The favicon is a separate 64px export (`public/favicon.png`) because a favicon is fetched
 * outside the document and must not pull a 50KB file on every page load.
 *
 * ── THE ARROWS HAVE A SIZE FLOOR ──────────────────────────────────────────────────
 *
 * The three send-arrows ride dotted trails that occupy roughly the outer sixth of the frame. Below
 * about 24px those trails stop resolving and read as fuzz around the envelope. So the mark is used at
 * 24px and up, and anywhere smaller wants a crop of the envelope-and-hexagon rather than a smaller
 * whole mark. Nothing in the app currently renders it below 24px.
 */

const MARK_SRC = '/brand/campaigns-mark.png';

export function CampaignsMark({
  className,
  /**
   * Pass only where the mark is the SOLE identification of the product. Beside a wordmark that
   * already reads "Hazcheck Campaigns" it makes a screen reader announce the name twice, so the
   * default is an empty alt — which marks it decorative rather than leaving it unlabelled.
   */
  alt = '',
}: {
  className?: string;
  alt?: string;
}) {
  return <img src={MARK_SRC} alt={alt} className={className} width={256} height={256} />;
}
